module.exports = __webpack_public_path__ + "static/media/beaverton-placeholder.825cc4ad.webp";